export default __webpack_public_path__ + "static/media/es.d0c4a613.svg";